import { render, staticRenderFns } from "./OrderBoxSellGoods.vue?vue&type=template&id=4c475930&scoped=true"
import script from "./OrderBoxSellGoods.vue?vue&type=script&lang=js"
export * from "./OrderBoxSellGoods.vue?vue&type=script&lang=js"
import style0 from "./OrderBoxSellGoods.vue?vue&type=style&index=0&id=4c475930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c475930",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderBoxStatus: require('/drone/src/components/OrderBox/OrderBoxStatus.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,OrderBoxKan: require('/drone/src/components/OrderBox/OrderBoxKan.vue').default})
